module.exports = __webpack_public_path__ + "img/213.problem_bed_smell.ce149047.svg";